var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorPowerup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5417 37.6667V94.1667H42.375V37.6667H23.5417ZM14.125 32.9583L32.9583 9.41667L51.7917 32.9583V103.583H14.125V32.9583ZM89.4583 75.3333V65.9167H75.3333V56.5H89.4583V47.0833H80.0417V37.6667H89.4583V28.25H70.625V94.1667H89.4583V84.75H80.0417V75.3333H89.4583ZM65.9167 18.8333H94.1667C95.4154 18.8333 96.613 19.3294 97.496 20.2124C98.379 21.0954 98.875 22.2929 98.875 23.5417V98.875C98.875 100.124 98.379 101.321 97.496 102.204C96.613 103.087 95.4154 103.583 94.1667 103.583H65.9167C64.6679 103.583 63.4704 103.087 62.5874 102.204C61.7044 101.321 61.2083 100.124 61.2083 98.875V23.5417C61.2083 22.2929 61.7044 21.0954 62.5874 20.2124C63.4704 19.3294 64.6679 18.8333 65.9167 18.8333Z",
    fill: "#413C35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPowerup);
export default __webpack_public_path__ + "static/media/color-powerup.d61c263ecace05708192362bff6e52f1.svg";
export { ForwardRef as ReactComponent };